import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { MARKETPLACE_COUNTRIES } from '../utils/marketplaceLocale';

/**
 * Compact country selector for the marketplace search bars ("Where to" → USA/UAE).
 */
export const CountrySelect = ({ value, onChange, compact = false }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = MARKETPLACE_COUNTRIES.find((c) => c.code === value) || MARKETPLACE_COUNTRIES[0];

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, []);

  return (
    <div ref={ref} className="relative flex-shrink-0">
      <button
        type="button"
        data-testid="marketplace-country-select"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 rounded-full bg-transparent hover:bg-gray-50 transition-colors text-gray-700 font-medium ${
          compact ? 'px-2.5 py-1.5 text-xs' : 'px-3 py-2 text-sm'
        }`}
      >
        <span aria-hidden="true">{current.flag}</span>
        <span>{current.label}</span>
        <ChevronDown className={`${compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white rounded-2xl shadow-[0_16px_40px_rgba(0,0,0,0.12)] z-50 overflow-hidden py-1.5">
          {MARKETPLACE_COUNTRIES.map((c) => (
            <button
              key={c.code}
              type="button"
              data-testid={`country-option-${c.code.toLowerCase()}`}
              onClick={() => { onChange(c.code); setOpen(false); }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-gray-50 transition-colors ${
                c.code === current.code ? 'text-gray-900 font-medium' : 'text-gray-600'
              }`}
            >
              <span aria-hidden="true">{c.flag}</span>
              <span className="flex-1">{c.label}</span>
              {c.code === current.code && <Check className="w-3.5 h-3.5 text-blue-600" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountrySelect;
